import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";
import Helper from "util/Helper";

/**
 * Risk stratification (bridge's risk-stratification module). phr displays the
 * latest assessment's level + AI summary on the Patient health overview card
 * and can TRIGGER a fresh one; evaluation/assignment stays in bridge.
 */
class RiskStratificationService {
  constructor() {
    this.apiService = new APIService();
    // Side effect: installs String.prototype.format for the URL templates.
    this.helper = new Helper();
  }

  /**
   * All assessments for a patient, newest-first — bare array of
   * [{ id, triggeredAt, riskLevel }]. No narrative here.
   */
  getHistory(patientId, onResponse, onError) {
    const url = APIConfig.riskStratification.history.format(patientId);

    return this.apiService.get(url, onResponse, onError);
  }

  /**
   * Kick off a NEW stratification for this patient, attributed to `docId`.
   *
   * A GET with a side effect, which is the server's shape, not a choice here —
   * so it must never be called from an effect or a retry wrapper. The response
   * is not the new assessment; callers re-read history/detail afterwards.
   */
  stratify(patientId, docId, onResponse, onError) {
    const url = APIConfig.riskStratification.stratify.format(patientId, docId);

    return this.apiService.get(url, onResponse, onError);
  }

  /**
   * One assessment in full — the ONLY endpoint carrying `riskSummary` (the AI
   * narrative). Display level is `updatedRiskLevel || riskLevel` (an
   * evaluator's correction wins over the raw AI level — bridge's rule).
   */
  getDetail(riskId, onResponse, onError) {
    const url = APIConfig.riskStratification.detail.format(riskId);

    return this.apiService.get(url, onResponse, onError);
  }
}

export default RiskStratificationService;
